import React from 'react'
import { UISizes, UITypes } from 'LibNeo/constants/UIConstants'
import { IconComponent } from 'LibNeo/components/Basic/Icon/Icon'

export const ClearIcon = <IconComponent name="close" type={UITypes.GREY} />

export const RemoveIcon = (
	<IconComponent name="close" type={UITypes.GREY} size={UISizes.EXTRASMALL} />
)
export const SuffixIcon = <IconComponent name="chevron-down" type={UITypes.GREY} />
